import { type BigNumber, bignumber } from 'mathjs';

export const parseDecimal = (value: string): BigNumber => bignumber(value);
